/**
 * Format time remaining until expiration
 * @param expiresAt - The expiration date
 * @param format - 'short' returns "5m" or "30s", 'long' returns "5m remaining" or "1h 30m remaining"
 * @returns Formatted time string or null if expired or no expiration
 */
export const formatTimeRemaining = (
  expiresAt: Date | undefined,
  format: 'short' | 'long' = 'short',
): string | null => {
  if (!expiresAt) return null;

  const now = new Date();
  const diff = expiresAt.getTime() - now.getTime();

  if (diff <= 0) {
    return format === 'long' ? 'Expired' : null;
  }

  const totalMinutes = Math.floor(diff / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (format === 'short') {
    if (totalMinutes > 0) {
      return `${totalMinutes}m`;
    }
    return `${seconds}s`;
  }

  if (hours > 0) {
    return `${hours}h ${minutes}m remaining`;
  }
  return `${minutes}m remaining`;
};
